import { render } from "./MoneyCreditModal.vue?vue&type=template&id=20bb9712&scoped=true&ts=true"
import script from "./MoneyCreditModal.vue?vue&type=script&lang=ts"
export * from "./MoneyCreditModal.vue?vue&type=script&lang=ts"

import "./MoneyCreditModal.vue?vue&type=style&index=0&id=20bb9712&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bb9712"]])

export default __exports__